import { render } from "./usergroupEidt.vue?vue&type=template&id=1a4b3041&scoped=true"
import script from "./usergroupEidt.vue?vue&type=script&lang=js"
export * from "./usergroupEidt.vue?vue&type=script&lang=js"

import "./usergroupEidt.vue?vue&type=style&index=0&id=1a4b3041&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4b3041"]])

export default __exports__